import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@welldev-group/rcl-select-box';
import formTripShape from '../../helpers/shapes';
import { BOOKING_CLASS, CABIN_CLASS } from '../../helpers/constant';
import disableOptionsByPriority from '../../helpers/disableOptionsByPriority';
import getSelectBoxData from '../../helpers/getSelectBoxData';

const SearchSelectOption = ({ field, trip, className, isDisabled, handleCabinClassChange }) => {
  const { bookingClass, cabinClass } = trip;
  const isBookingClassField = field === BOOKING_CLASS;
  const isCabinClassField = field === CABIN_CLASS;

  const { placeholderText, options, values } = getSelectBoxData(
    field,
    bookingClass?.value,
    cabinClass?.value,
  );

  const getAvailableOptions = () => {
    if (isCabinClassField) {
      return disableOptionsByPriority(field, options, cabinClass?.initialValue);
    }

    return options;
  };

  const handleChange = selectedOptions => {
    switch (field) {
      case BOOKING_CLASS: {
        const selectedValues = selectedOptions?.map(option => option.value);
        bookingClass.onChange(selectedValues || []);
        break;
      }
      case CABIN_CLASS:
        handleCabinClassChange(selectedOptions.value);
        break;
      default:
        break;
    }
  };

  return (
    <SelectBox
      className={className}
      placeholderText={placeholderText}
      options={getAvailableOptions()}
      onChange={handleChange}
      width="full"
      isMulti={isBookingClassField}
      value={values}
      isClearable={isBookingClassField}
      isDisabled={isDisabled}
    />
  );
};

SearchSelectOption.defaultProps = {
  className: '',
  handleCabinClassChange: () => {},
  isDisabled: false,
};

SearchSelectOption.propTypes = {
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  trip: PropTypes.shape(formTripShape).isRequired,
  handleCabinClassChange: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default SearchSelectOption;
